import {
    IOptionPickerTextItem,
    OPTION_PICKER_TYPE_TEXT,
} from '@vfde-brix/ws10/option-picker';
import { StateProps } from 'Container/App/interface';
import { Price } from '@vfde-brix/ws10/core';
import mountOptionPicker from 'Component/OptionPicker';
import { PriceType } from '@vfde-sails/glados-v2';
import { changeCaseSize } from 'Container/App/slice';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';
import { mapStateToProps } from 'Container/App/selectors';

/**
 * Mount the case size picker
 */
const mountCaseSizeOptionPicker = (
    containerId: string,
) => {
    const dispatch = useDispatch();
    const items: IOptionPickerTextItem[] = [];

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        dispatch(changeCaseSize(target.value));
    };

    const caseSizeOptionPicker = mountOptionPicker(containerId, 'option-picker-capacity', OPTION_PICKER_TYPE_TEXT, items, onChange);

    startAppListening({
        predicate: (action, currentState, previousState) => {
            const currentStateProps = mapStateToProps(currentState);
            const previousStateProps = mapStateToProps(previousState);

            return currentStateProps.availableCaseSizes !== previousStateProps.availableCaseSizes
                || currentStateProps.caseSizesForColor !== previousStateProps.caseSizesForColor
                || currentStateProps.currentCaseSize !== previousStateProps.currentCaseSize
                || currentStateProps.customerConfig.isHardwareOnly !== previousStateProps.customerConfig.isHardwareOnly
                || currentStateProps.customerConfig.paymentMethod !== previousStateProps.customerConfig.paymentMethod
            ;
        },
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const stateProps = mapStateToProps(listenerApi.getState());

            caseSizeOptionPicker?.update({
                items: convertCaseSizesFromApiToCaseSizeOptionPickerItems(stateProps),
            });
        },
    });

    return caseSizeOptionPicker;
};

/**
 * Convert case sizes from API to option picker items
 */
const convertCaseSizesFromApiToCaseSizeOptionPickerItems = (
    { currentCaseSize, availableCaseSizes, caseSizesForColor, customerConfig: { isHardwareOnly, paymentMethod } }: StateProps,
): IOptionPickerTextItem[] | undefined => {
    const items: IOptionPickerTextItem[] = [];

    for (const caseSize of availableCaseSizes) {
        const optChecked = currentCaseSize === caseSize.displayLabel;
        const optDisabled = !caseSizesForColor.includes(caseSize.displayLabel);
        const price = isHardwareOnly || paymentMethod === PriceType.Onetime
            ? caseSize.hardwareOnlyPrice.gross
            : caseSize.hardwareWithTariffPrice.gross
        ;

        items.push({
            stdValue: `${caseSize.displayLabel}`,
            stdPrimaryLabel: caseSize.displayLabel,
            stdSecondaryLabel: price ? `${Price.fromNumber(price).toString()} €` : undefined,
            optChecked,
            optDisabled,
        });
    }

    return items;
};

export default mountCaseSizeOptionPicker;
